import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { GlobeHemisphereWest, SignOut, User } from '@phosphor-icons/react';

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const roleColors = {
    Government: 'text-blue-400',
    Enterprise: 'text-purple-400',
    NGO: 'text-green-400',
    Farmer: 'text-amber-400',
    Developer: 'text-cyan-400'
  };

  return (
    <nav className="glass-panel border-b border-white/10 sticky top-0 z-50" data-testid="main-navbar">
      <div className="max-w-[1920px] mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/dashboard" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-testid="logo-link">
            <GlobeHemisphereWest size={32} weight="bold" className="text-emerald-500" />
            <div>
              <h1 className="text-xl font-black text-white tracking-tight">GEODOMINUS</h1>
              <p className="text-[10px] text-gray-400 uppercase tracking-[0.2em]">Intelligence Platform</p>
            </div>
          </Link>

          {/* Nav Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/dashboard" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="nav-dashboard">
              Dashboard
            </Link>
            <Link to="/map" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="nav-map">
              Interactive Map
            </Link>
            <Link to="/suites" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="nav-suites">
              Product Suites
            </Link>
            <Link to="/sdg-tracker" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="nav-sdg">
              SDG Tracker
            </Link>
          </div>

          {/* User Menu */}
          <div className="flex items-center gap-4">
            {user && (
              <div className="flex items-center gap-3 px-4 py-2 bg-white/5 rounded border border-white/10">
                <User size={20} className={roleColors[user.role] || 'text-white'} weight="duotone" />
                <div className="text-left">
                  <p className="text-xs text-white font-medium">{user.name}</p>
                  <p className={`text-[10px] uppercase tracking-wider ${roleColors[user.role] || 'text-gray-400'}`}>
                    {user.role}
                  </p>
                </div>
              </div>
            )}
            <button
              onClick={handleLogout}
              className="p-2 hover:bg-white/10 rounded transition-all duration-200"
              data-testid="logout-button"
              title="Logout"
            >
              <SignOut size={20} className="text-gray-400 hover:text-white" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};
